import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    initAgentConfig: false,
    userInfo: "", //当前用户信息
    corpId: "", //企业主体id
    agentId: "", //应用id
    configId: "", //表单配置id
    tenantId: "", //商户id
  },
  mutations: {
    SET_INIT_AGENT_CONFIG: (state, data) => {
      state.initAgentConfig = data;
    },
    SET_USERINFO: (state, data) => {
      state.userInfo = data;
    },
    SET_CORPID: (state, data) => {
      if (data) {
        state.corpId = data;
        localStorage.setItem("corpId", data);
      } else {
        state.corpId = localStorage.getItem("corpId")
          ? localStorage.getItem("corpId")
          : null;
      }
    },
    SET_AGENTID: (state, data) => {
      if (data) {
        state.agentId = data;
        sessionStorage.setItem("agentId", data);
      } else {
        state.agentId = sessionStorage.getItem("agentId")
          ? sessionStorage.getItem("agentId")
          : null;
      }
    },
    SET_CONFIGID: (state, data) => {
      state.configId = data;
    },
    SET_TENANTID: (state, data) => {
        //  state.tenantId = data;
      if (data) {
        state.tenantId = data;
        sessionStorage.setItem("tenantId", data);
      } 
      else {
        state.tenantId = sessionStorage.getItem("tenantId")
          ? sessionStorage.getItem("tenantId")
          : null;
      }
    },
  },
  actions: {},
  modules: {},
  getters: {
    initAgentConfig: (state) => state.initAgentConfig,
    userInfo: (state) => state.userInfo,
    corpId: (state) => state.corpId,
    agentId: (state) => state.agentId,
    configId: (state) => state.configId,
    tenantId: (state) => state.tenantId,
  },
});
